import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Icon } from '@resy/ui-kitchen';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import { getRetinaImage } from '../../AmexMarketingUtils/AmexUtils';
import './AmexPlatinumNightsBanner.scss';

const AmexPlatinumNightsBanner = (
  {
    awsFolderName,
    baseRequestUrl,
    matchMedia,
    bannerConfig,
  }
) => {
  if (!bannerConfig || Object.keys(bannerConfig).length === 0) return null;

  const {
    header,
    copy,
    card_image: cardImg,
    images: {
      desktop: desktopImg = {},
      mobile: mobileImg = {},
    } = {},
    logo_cobrand: logoCobrand,
    images_intro: {
      desktop: introImgDesktop = {},
      mobile: introImgMobile = {},
    },
  } = bannerConfig;

  const urlPrefix = `${baseRequestUrl}${awsFolderName}/bannerImages/`;
  const heroImageName = getRetinaImage(desktopImg, mobileImg, matchMedia.lg);
  const heroImage = `${urlPrefix}${heroImageName}`;
  const cardImage = `${baseRequestUrl}${awsFolderName}/images/${cardImg}`;
  const introImageName = getRetinaImage(introImgDesktop, introImgMobile, matchMedia.lg);
  const introImage = `${urlPrefix}${introImageName}`;
  const cobrandLogo = `${urlPrefix}${logoCobrand}`;

  const sanitizedHeader = sanitizeString(header);
  const sanitizedCopy = sanitizeString(copy);

  const renderHeroBanner = () => (
    <div className="AmexPlatinumNightsBanner__hero">
      {matchMedia.md ? (
        <div
          className="AmexPlatinumNightsBanner__hero--image"
          style={{ backgroundImage: `url(${heroImage})` }}
        />
      ) : (
        <img
          className="AmexPlatinumNightsBanner__image-mobile"
          src={heroImage}
          alt=""
        />
      )}
      {logoCobrand && (
        <div className="container">
          <Icon
            role="img"
            className="AmexPlatinumNightsBanner__logo"
            url={cobrandLogo}
          />
        </div>
      )}
    </div>
  );

  const renderIntroBanner = () => (
    <div className="AmexPlatinumNightsBanner__intro--wrapper">
      <div className={cx('AmexPlatinumNightsBanner__intro--content',
        { withCard: !!cardImg })}
      >
        {header && (
          <h1
            className="AmexPlatinumNightsBanner__intro--title"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: sanitizedHeader,
            }}
          />
        )}
        {copy && (
          <p
            className="AmexPlatinumNightsBanner__intro--text"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: sanitizedCopy,
            }}
          />
        )}
      </div>
      <div
        className="AmexPlatinumNightsBanner__intro--image"
        style={{ backgroundImage: matchMedia.lg && `url(${introImage})` }}
      >
        {cardImg && (
          <img
            className="AmexPlatinumNightsBanner__intro--card"
            src={cardImage}
            alt=""
          />
        )}
        {!matchMedia.lg && (
          <img
            className="AmexPlatinumNightsBanner__intro--image-mobile"
            src={introImage}
            alt=""
          />
        )}
      </div>
    </div>
  );

  return (
    <section className="AmexPlatinumNightsBanner">
      {renderHeroBanner()}
      <div className="AmexPlatinumNightsBanner__intro">
        <div className="container">
          {renderIntroBanner()}
        </div>
      </div>
    </section>
  );
};

export default AmexPlatinumNightsBanner;

AmexPlatinumNightsBanner.propTypes = {
  awsFolderName: PropTypes.string.isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    ipadLandscape: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  bannerConfig: PropTypes.shape({
    header: PropTypes.string,
    copy: PropTypes.string,
    card_image: PropTypes.string,
    images: PropTypes.shape({
      desktop: PropTypes.shape({}),
      mobile: PropTypes.shape({}),
    }).isRequired,
    logo_cobrand: PropTypes.string,
    images_intro: PropTypes.shape({
      desktop: PropTypes.shape({}),
      mobile: PropTypes.shape({}),
    }),
  }).isRequired,
};
